export const ICON = {
  ENLARGE: 'enlarge',
  SUCCESS_ROUND_BLUE: 'success-round-blue',
  MORE_INFO_ROUND_BLUE: 'more-info-round-blue',
  SENT_LETTER: 'sent-letter',
  NEWSLETTER_WHITE: 'newsletter-white',
  ENVELOPE: 'envelope',
  ENVELOPE_2: 'envelope-2',
  ENVELOPE_WITH_CONTENT: 'envelope-with-content',
  ENVELOPE_ROUND_BLACK: 'envelope-round-black',
  ENVELOPE_ROUND_BLUE: 'envelope-round-blue',
  ENVELOPE_ROUND_GRAY: 'envelope-round-gray',
  ENVELOPE_RECT_BLUE: 'envelope-rect-blue',
  NEWSLETTER_RECT_BLUE: 'newsletter-rect-blue',
  TWITTER: 'twitter',
  TWITTER_ROUND_BLACK: 'twitter-round-black',
  TWITTER_ROUND_BLUE: 'twitter-icon-color',
  X_PURPLE: 'x-purple',
  X: 'x',
  X_ROUND_BLACK: 'x-round-black',
  THUMB_UP: 'thumb-up',
  LINKEDIN: 'linkedin',
  LINKEDIN_ROUND_BLACK: 'linkedin-round-black',
  LINKEDIN_ROUND_BLUE: 'linkedin-round-blue',
  TAG: 'tag',
  TELEGRAM: 'telegram',
  TELEGRAM_ROUND_BLACK: 'telegram-round-black',
  TELEGRAM_ROUND_BLUE: 'telegram-round-blue',
  TELEGRAM_ROUND_PURPLE: 'telegram-round-purple',
  TELEGRAM_PURPLE: 'telegram-purple',
  FACEBOOK: 'facebook',
  FACEBOOK_ROUND_BLACK: 'facebook-round-black',
  FACEBOOK_ROUND_BLUE: 'facebook-round-blue',
  FACEBOOK_PURPLE: 'facebook-purple',
  YOUTUBE_ROUND_BLACK: 'youtube-round-black',
  WHATSUP_ROUND_GREEN: 'whatsapp-round-green',
  WHATSUP_ROUND_BLACK: 'whatsapp-round-black',
  SAVE_ROUND_BLACK: 'save-round-black',
  SAVE_WHITE: 'save-white',
  SAVE_PURPLE: 'save-purple',
  SHARE: 'share',
  LOCK: 'lock',
  GOOGLE: 'google',
  FILTER: 'filter',
  PENCIL: 'pencil',
  SEARCH: 'search',
  MAGNIFIER: 'magnifier',
  MAGNIFIER_2: 'magnifier-2',
  MAGNIFIER_3: 'magnifier-3',
  ADD_COMPANY_RECT_GREEN: 'add-company-rect-green',
  PIN: 'pin',
  PIN_PURPLE: 'pin-purple',
  FL: 'fl',
  IL: 'il',
  IL_DARK: 'il-dark',
  REGISTRATION_COMPLETE: 'registration-complete',
  RSS: 'rss',
  RSS_ORANGE: 'rss-orange',
  PLUS: 'plus',
  COMMENT_COUNT_ROUND_BLACK: 'comments-count-round-black',
  REDDIT_ROUND_ORANGE: 'reddit-round-orange',
  REDDIT_ROUND_BLACK: 'reddit-round-black',
  EYE: 'eye',
  FILM: 'film-icon',
  ARROW_RIGHT_WHITE: 'white-arrow-right',
  BELL_WHITE: 'bell-white',
  ONE_SIGNAL_ACTIVE: 'one-signal-active',
  ONE_SIGNAL_INACTIVE: 'one-signal-inactive',
  REDO: 'redo',
  WALKING_FINGERS_ROUND_BLACK: 'walking-fingers-round-black',
  LABEL: 'label',
  DOWNLOAD: 'download',
  UPLOADED_ROUND_GREEN: 'uploaded-round-green',
  UPLOAD_ROUND_BLACK: 'upload-round-black',
  COMPARE_BROKERS: 'compare-brokers-icon',
  EDUCATION_FROM_BROKERS: 'education-from-broke-icon',
  TRUSTED_GURUS: 'trusted-gurus-icon',
  UNUSUAL_MARKETS: 'unusual-markets-icon',
  MARKET_WISDOM: 'market-wisdom-icon',
  ECONOMICS: 'economics-icon',
  VIDEO: 'videos-icon',
  TRADING_TECHNIQUES: 'trading-techniques-icon',
  WAR_STORIES: 'war-stories-icon',
  TRADING_PSYCHOLOGY: 'trading-psychology-icon',
  BASICS: 'basics-icon',
  FOREX_OPTIONS: 'forex-options-icon',
  TECHNICAL_ANALYSIS: 'technical-analysis-icon',
  FUNDAMENTAL_STRATEGY: 'fundamental-strategy-icon',
  TRADING_RULES: 'trading-rules-icon',
  EDUCATION_HUB_DESKTOP: 'education-hub-desktop',
  EDUCATION_HUB_MOBILE: 'education-hub-mobile',
  EDUCATION_HUB_BANNER_LG: 'education-hub-banner-lg',
  EDUCATION_HUB_BANNER_SM: 'education-hub-banner-sm',
  LIVE_FEED: 'live-feed',
  ARROW_DOWN_PURPLE: 'arrow-down-purple',
  ARROW_DOWN_WHITE: 'arrow-down-white',
  ARROW_RIGHT_GREY: 'arrow-right-grey',
  BURGER_MENU: 'burger-menu',
  BURGER_MENU_PURPLE: 'burger-menu-purple',
  MENU_BROKERS: 'menu-brokers',
  MENU_CALENDAR: 'menu-calendar',
  MENU_NEWS: 'menu-news',
  CROSS_IN_CIRCLE: 'cross-in-circle',
  HOME: 'home',
  CROSS: 'cross',
  LOG_IN: 'log-in',
  WARNING: 'warning-icon',
  WARNING_CIRCLE: 'warning',
  FLASH_ICON: 'flash-icon',
  PLUS_CIRCLE_ICON: 'plus-circle-icon',
  MINUS_CIRCLE_ICON: 'minus-circle-icon',
  ARROW_STICK_RIGHT_PURPLE: 'arrow-stick-right-purple',
  BULLHORN: 'bullhorn-white',
  BULLHORN_DISABLED: 'bullhorn-purple-disabled',
  ARROW_STICK_RIGHT_WHITE: 'arrow-stick-right-white',
  DIAMOND: 'diamond',
  HASHTAG: 'hashtag',
  WARNING_404: 'warning-404',
  LIVEBYTES: 'livebytes-purple',
  CAMERA: 'camera',
  BULL: 'bull',
  BRIEFCASE_ROUND_BLUE: 'briefcase-round-blue',
  ADD_POST_ROUND_BLACK: 'add-post-round-black',
  LINK_ROUND_BLACK: 'link-round-black',
  GEAR_ROUND_BLACK: 'gear-round-black',
  PENCIL_ROUND_BLACK: 'pencil-round-black',
  FILE_ROUND_BLACK: 'file-round-black',
  RENEW_ROUND_BLACK: 'renew-round-black',
  RENEW: 'renew',
  DONT_RENEW: 'dont-renew',
  QUESTION: 'question',
  FILE_STARRED: 'file-starred',
  MAGNIFIER_STARRED: 'magnifier-starred',
  TRASH_ROUND_BLACK: 'trash-round-black',
  FOLLOW_TAG: 'follow-tag',
  TEXT_SIZE: 'text-size',
  UNFOLLOW_TAG: 'unfollow-tag',
  CHECKBOX_CHECK: 'checkbox-check',
  REFRESH: 'refresh',
  UPLOAD: 'upload',
  TRASHCAN: 'trashcan',
  PEN: 'pen',
  OUTLINE_BADGE_CHECK: 'outline-badge-check',
  LEVERAGE: 'leverage',
  MONEY_WAVY: 'money-wavy',
  CERTIFICATE: 'certificate',
  FILTER_PURPLE: 'filter-purple',
  ARROW_STICK_LEFT_PURPLE: 'arrow-stick-left-purple',
  SCALE_BALANCED: 'scale-balanced',
  CHECK: 'check',
  COPY: 'copy',
  ARROW_UP_WHITE: 'arrow-up-white',
  TICK: 'tick',
  STAR: 'star',
  USER_FOLLOWING: 'user-following',
  CATEGORIES: 'categories'
}
